import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}
const delinkEMS = (deviceid: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.modifyDevice),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),

    //headers: { ...getHeaders(), 'x-user-id': 'test', 'x-channel-id': '322287787654' },
    body: {
      deviceDetails: {
        deviceId: deviceid,
        actionType: 'DELINK',
      },
    },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { delinkEMS }
